/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Add_Operator_User_NiagaraInputs */



/**
* | output |
* | --- |
* | "User" |
*
* @param {Module_Add_Operator_User_NiagaraInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_add_operator_user_niagara = /** @type {((inputs?: Module_Add_Operator_User_NiagaraInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Add_Operator_User_NiagaraInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("User")
	return /** @type {LocalizedString} */ ("Utilisateur")
});